import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { combineReducers, Reducer } from 'redux'
import * as collectionlist from '../collectionlist/reducer'
import * as screen from '../screen/reducer'
import * as settings from '../settings/reducer'
import * as audioplayer from '../audioplayer/reducer'
import * as lockapp from '../lockapp/reducer'
import * as map from '../map/reducer'
import * as scanner from '../scanner/reducer'
import * as mediaitems from '../mediaitems/reducer'
import * as badges from '../badges/reducer'
import * as forms from '../forms/reducer'
import { readyAction } from './actions'
import { getConfiguration } from '../configuration/index'

export interface StoreState {
	readonly collectionlist: collectionlist.StoreState
	readonly screen: screen.StoreState
	readonly settings: settings.StoreState
	readonly ready: boolean
	readonly audioplayer: audioplayer.StoreState
	readonly lockapp: lockapp.StoreState
	readonly map: map.StoreState
	readonly scanner: scanner.StoreState
	readonly mediaitems: mediaitems.StoreState
	readonly badges: badges.StoreState
	readonly forms: forms.StoreState
}

const readyReducer = reducerWithInitialState(false).case(readyAction, (_state, _payload) => true)

let reducer: Reducer<StoreState>

export function getRootReducer() {
	if (reducer === undefined) {
		// had to wait until configuration was set
		reducer = combineReducers<StoreState>(getConfiguration().customiseReducers({
				collectionlist: collectionlist.reducer,
				screen: screen.reducer,
				settings: settings.reducer,
				ready: readyReducer,
				audioplayer: audioplayer.reducer,
				lockapp: lockapp.reducer,
				map: map.reducer,
				scanner: scanner.reducer,
				mediaitems: mediaitems.reducer,
				badges: badges.reducer,
				forms: forms.reducer,
			}),
		)
	}
	return reducer
}
